import RecentSearches from 'recent-searches';

const searches = new RecentSearches({
  limit: 5, // max number of entries that will be persisted
  namespace: 'client-list-search', // custom localStorage namespace
});

export const getRecentSearches = () => {
  const recentSearches = searches.getRecentSearches() || [];
  return recentSearches.map((item) => item.data);
};

const formatClientData = (client) => {
  let transformed = null;
  // not sure if it's still actual definitely can be removed after final migration to infinite scroll pagination
  if (client.phoneNumbers) {
    transformed = { ...client, phoneNumbers: [...client.phoneNumbers], conciergeItems: false };
  } else {
    transformed = { ...client, conciergeItems: false };
  }
  return transformed;
};

export const setRecentSearch = (query, data) => {
  searches.setRecentSearch(query, formatClientData(data));
};
